import { InsurancePolicy } from "./InsurancePolicy/InsurancePolicy";
import { NoInsurance } from "./NoInsurance";
import { NoInsuranceModal } from "./NoInsurance/NoInsuranceModal";
import { ConnectPolicy } from "./ConnectPolicy";
import {
  useIsStateFarmPartitioned,
  useIsSso,
} from "../../app/Providers/AppContext";
import { usePolicies } from "./usePolicies";
import { InsuranceContextProvider } from "./InsuranceContext";
import { Fragment } from "react";

export const Insurance = () => {
  const policies = usePolicies();
  const isSso = useIsSso();
  const hasStateFarmPartition = useIsStateFarmPartitioned();
  const isStateFarmSsoLogin = hasStateFarmPartition && isSso;

  return policies.length === 0 ? (
    <>
      <NoInsurance
        isStateFarmPartner={hasStateFarmPartition}
        isStateFarmSso={isStateFarmSsoLogin}
      />
      {/* Do not display NoInsuranceModal for State Farm SSO partner login*/}
      {!isStateFarmSsoLogin && <NoInsuranceModal />}
    </>
  ) : (
    <InsuranceContextProvider policies={policies}>
      {policies.map((policy) => (
        <Fragment key={policy.policyNumber}>
          <InsurancePolicy policy={policy} />
        </Fragment>
      ))}
      {!hasStateFarmPartition && <ConnectPolicy />}
    </InsuranceContextProvider>
  );
};
